/* Lamberty Munich · PERF CANARY 13.10.2026 (Owner-GO): Hoverbilder der Startseiten-Kacheln
   (snippets/lm-home-card.liquid) erst bei echter Maus-Interaktion laden.
   Touch-Geraete (nicht "hover: hover" und "pointer: fine") fordern das Hoverbild nie an.
   Das normale Kachelbild bleibt unveraendert. */
(function () {
  if (window.lmHoverLazyBound) return;
  window.lmHoverLazyBound = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  function load(link) {
    var img = link.querySelector('img[data-lm-hover-src]');
    if (!img) return;
    var srcset = img.getAttribute('data-lm-hover-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-lm-hover-src'));
    img.removeAttribute('data-lm-hover-src');
    img.removeAttribute('data-lm-hover-srcset');
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = e.target;
    var link = t && t.closest ? t.closest('.lm-hp__card-link') : null;
    if (link) load(link);
  }, { passive: true });
})();
